export default __webpack_public_path__ + "static/media/connect_wallet_icon.e9bd62e8.svg";